import { injectGlobal as _injectGlobal } from "emotion";
import prefetch from 'prefetchit';
import electron from "../../../public/static/icons/electron.png";
import jest from "../../../public/static/icons/jest.png";
import knex from "../../../public/static/icons/knex.png";
import objection from "../../../public/static/icons/objection.png";
import redux from "../../../public/static/icons/redux.png";
import materialui from "../../../public/static/icons/materialui.png";
import graphql from "../../../public/static/icons/graphql.svg";
import mobx from "../../../public/static/icons/mobx.png";
import mst from "../../../public/static/icons/mst.svg";
import emotion from "../../../public/static/icons/emotion.png";
import sqlite from "../../../public/static/icons/sqlite.png";
import rxjs from "../../../public/static/icons/rxjs.png";
import couchdb from "../../../public/static/icons/couchdb.png";
import lerna from "../../../public/static/icons/lerna.png";
import parcel from "../../../public/static/icons/parcel.png";
import rxdb from "../../../public/static/icons/rxdb.png";
import auth0 from "../../../public/static/icons/auth0.png";
import router from "../../../public/static/icons/router.png"; // Prefetch images

prefetch.bulk(electron, jest, knex, objection, redux, materialui, graphql, mobx, mst, emotion, sqlite, rxjs, couchdb, lerna, parcel, rxdb, auth0, router);
const iconClass = `tag-icon-${Math.round(Math.random() * 10000)}`;

_injectGlobal({
  [`.${iconClass}`]: {
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '90%'
  }
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

export default {
  javascript: {
    name: 'Javascript',
    className: 'devicon-javascript-plain colored',
    styles: {
      position: 'relative',
      '&:after': {
        content: '""',
        position: 'absolute',
        top: 2,
        right: 2,
        bottom: 2,
        left: 2,
        background: '#3a3a3a',
        zIndex: -1
      }
    }
  },
  node: {
    name: 'Node.js',
    className: 'devicon-nodejs-plain colored',
    styles: {
      color: '#78bc8a'
    }
  },
  express: {
    name: 'Express',
    className: 'devicon-express-original colored'
  },
  mobx: {
    name: 'MobX',
    className: iconClass,
    styles: {
      backgroundImage: `url("${mobx}")`
    }
  },
  mst: {
    name: 'MobX State Tree',
    className: iconClass,
    styles: {
      backgroundImage: `url("${mst}")`
    }
  },
  parcel: {
    name: 'Parcel Bundler',
    className: iconClass,
    styles: {
      backgroundImage: `url("${parcel}")`
    }
  },
  emotion: {
    name: 'Emotion',
    className: iconClass,
    styles: {
      backgroundImage: `url("${emotion}")`
    }
  },
  sqlite: {
    name: 'SQLite',
    className: iconClass,
    styles: {
      backgroundImage: `url("${sqlite}")`
    }
  },
  rxjs: {
    name: 'RxJS',
    className: iconClass,
    styles: {
      backgroundImage: `url("${rxjs}")`
    }
  },
  rxdb: {
    name: 'RxDB',
    className: iconClass,
    styles: {
      backgroundImage: `url("${rxdb}")`
    }
  },
  couchdb: {
    name: 'CouchDB',
    className: iconClass,
    styles: {
      backgroundImage: `url("${couchdb}")`
    }
  },
  auth0: {
    name: 'Auth0',
    className: iconClass,
    styles: {
      backgroundImage: `url("${auth0}")`
    }
  },
  lerna: {
    name: 'Lerna',
    className: iconClass,
    styles: {
      backgroundImage: `url("${lerna}")`
    }
  },
  graphql: {
    name: 'GraphQL',
    className: iconClass,
    styles: {
      backgroundImage: `url("${graphql}")`
    }
  },
  sequelize: {
    name: 'Sequelize ORM',
    className: 'devicon-sequelize-plain',
    styles: {
      color: '#3d77b8'
    }
  },
  knex: {
    name: 'Knex',
    className: iconClass,
    styles: {
      backgroundImage: `url("${knex}")`
    }
  },
  objection: {
    name: 'Objection.js',
    className: iconClass,
    styles: {
      backgroundImage: `url("${objection}")`
    }
  },
  babel: {
    name: 'Babel',
    className: 'devicon-babel-plain',
    styles: {
      color: '#444444'
    }
  },
  jest: {
    name: 'Jest',
    className: iconClass,
    styles: {
      backgroundImage: `url("${jest}")`,
      backgroundSize: '70% !important'
    }
  },
  webpack: {
    name: 'Webpack',
    className: 'devicon-webpack-plain colored'
  },
  react: {
    name: 'React',
    className: 'devicon-react-original colored'
  },
  router: {
    name: 'React Router',
    className: iconClass,
    styles: {
      backgroundImage: `url("${router}")`
    }
  },
  redux: {
    name: 'Redux',
    className: iconClass,
    styles: {
      backgroundImage: `url("${redux}")`
    }
  },
  materialui: {
    name: 'Material UI',
    className: iconClass,
    styles: {
      backgroundImage: `url("${materialui}")`,
      backgroundSize: '82.5% !important'
    }
  },
  travis: {
    name: 'TravisCI',
    className: 'devicon-travis-plain colored'
  },
  postgresql: {
    name: 'PostgreSQL',
    className: 'devicons devicons-postgresql',
    styles: {
      color: '#40658d'
    }
  },
  docker: {
    name: 'Docker',
    className: 'devicon-docker-plain colored'
  },
  typescript: {
    name: 'Typescript',
    className: 'devicon-typescript-plain colored'
  },
  vscode: {
    name: 'Visual Studio Code',
    className: 'devicon-visualstudio-plain',
    styles: {
      color: '#3976bf'
    }
  },
  atom: {
    name: 'Atom',
    className: 'devicon-atom-original colored'
  },
  electron: {
    name: 'Electron',
    className: iconClass,
    styles: {
      backgroundImage: `url("${electron}")`
    }
  }
};